module.exports = __webpack_public_path__ + "img/temporaryImgGrayDrop.b2474b82.png";